`<template>
  <div class="animated fadeIn">
    <b-row class="mt-2 mb-2">
      <b-col>
        <h2>ภาพรวม</h2>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div>
            <b-tabs content-class="mt-3">
              <b-tab title="จำนวนบริษัท" active>
                <div>
                  <b-row>
                    <b-col cols="9" sm="6" md="3">จำนวนบริษัททั้งหมด</b-col>
                    <b-col cols="3" sm="6" md="3">{{ stat.companyNum }}</b-col>
                  </b-row>
                </div>
                <div>
                  <b-row>
                    <b-col cols="9" sm="6" md="3">บริษัทขนส่ง</b-col>
                    <b-col cols="3" sm="6" md="3">{{ stat.companyCarrierNum }}</b-col>
                  </b-row>
                </div>
                <div>
                  <b-row>
                    <b-col cols="9" sm="6" md="3">ผู้ผลิต/ผู้จัดจำหน่าย</b-col>
                    <b-col cols="3" sm="6" md="3">{{ stat.companyFactoryNum }}</b-col>
                  </b-row>
                </div>
                <div>
                  <b-row>
                    <b-col cols="9" sm="6" md="3">ชิปปิ้งและเฟรทฟอร์เวิดเดอร์</b-col>
                    <b-col cols="3" sm="6" md="3">{{ stat.companyShipperNum }}</b-col>
                  </b-row>
                </div>
                <div>
                  <b-row>
                    <b-col cols="9" sm="6" md="3">โกดังสินค้า</b-col>
                    <b-col cols="3" sm="6" md="3">{{ stat.companyWarehouseNum }}</b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="ที่ตั้งสำนักงานใหญ่">
                <b-form-group>
                  <b-form-radio-group
                    id="sort-hq"
                    v-model="sortHq"
                    :options="sortOption"
                    @input="stat.groupCompanyHQProvinceNum.sort(sortBy[sortHq])"
                  ></b-form-radio-group>
                </b-form-group>
                <div v-for="(item,index) in stat.groupCompanyHQProvinceNum" :key="index">
                  <b-row v-if="item._id != null">
                    <b-col cols="9" sm="6" md="3">{{ item._id }}</b-col>
                    <b-col cols="3" sm="6" md="3">{{ item.count }}</b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="ลานจอดรถ">
                <b-form-group>
                  <b-form-radio-group
                    id="sort-parking"
                    v-model="sortParking"
                    :options="sortOption"
                    @input="stat.groupparkingBaseNum.sort(sortBy[sortParking])"
                  ></b-form-radio-group>
                </b-form-group>
                <div v-for="(item,index) in stat.groupparkingBaseNum" :key="index">
                  <b-row v-if="item._id != null">
                    <b-col cols="9" sm="6" md="3">{{ item._id }}</b-col>
                    <b-col cols="3" sm="6" md="3">{{ item.count }}</b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="ลักษณะสินค้าที่รับ">
                <b-form-group>
                  <b-form-radio-group
                    id="sort-cargo"
                    v-model="sortCargo"
                    :options="sortOption"
                    @input="stat.groupnatureOfCargoNum.sort(sortBy[sortCargo])"
                  ></b-form-radio-group>
                </b-form-group>
                <div v-for="(item,index) in stat.groupnatureOfCargoNum" :key="index">
                  <b-row v-if="item._id != null">
                    <b-col cols="9" sm="6" md="3">{{ item._id }}</b-col>
                    <b-col cols="3" sm="6" md="3">{{ item.count }}</b-col>
                  </b-row>
                </div>
              </b-tab>
              <b-tab title="รถที่มีในระบบ">
                <b-form-group>
                  <b-form-radio-group
                    id="sort-truck"
                    v-model="sortTruck"
                    :options="sortOption"
                    @input="stat.groupownTruckNumByTypeNum.sort(sortBy[sortTruck])"
                  ></b-form-radio-group>
                </b-form-group>
                <div v-for="(item,index) in stat.groupownTruckNumByTypeNum" :key="index">
                  <b-row v-if="item._id != null">
                    <b-col cols="9" sm="6" md="3">{{ item._id }}</b-col>
                    <b-col cols="3" sm="6" md="3">{{ item.count }}</b-col>
                  </b-row>
                </div>
              </b-tab>
            </b-tabs>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import AppInfo from '../../../services/http/AppInfo'

export default {
  data () {
    return {
      stat: null,
      sortOption: [
        { text: 'มาก-น้อย', value: 'desc' },
        { text: 'น้อย-มาก', value: 'asc' }
      ],
      sortHq: null,
      sortParking: null,
      sortCargo: null,
      sortTruck: null,
      sortBy: {
        desc: (a, b) => this.$moment(b.count) - this.$moment(a.count),
        asc: (a, b) => this.$moment(a.count) - this.$moment(b.count)
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    async init () {
      try {
        let appinfo = new AppInfo()
        let statResult = await appinfo.getSystemStat()
        if (statResult.code === 1) {
          let stat = statResult.data

          if (stat.groupownTruckNumByTypeNum.length > 0) {
            let fourWheel = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('4 ล้อ'))
            let sixWheel = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('6 ล้อ'))
            let tenWheel = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('10 ล้อ'))
            let puang = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('พ่วง'))
            let trailerHead = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('หัวลาก'))
            let trailer = stat.groupownTruckNumByTypeNum.filter(x => x._id.includes('เทรลเลอร์'))
            stat.groupownTruckNumByTypeNum = [
              ...fourWheel,
              ...sixWheel,
              ...tenWheel,
              ...puang,
              ...trailerHead,
              ...trailer
            ]
          }
          this.stat = stat
        } else {
          alert('พบข้อผิดพลาด')
        }
      } catch (error) {
        alert(error.message)
      }
    }
  }
}
</script>
`
